// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product Solutions Section Styles */
.scl--web-page-product-section-box{
    min-height: 1212px;
    width: 100%;
    background: #FFFFFF;
}
.scl--web-page-product-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 var(--global-desktop-padding-left);
  max-width: var(--global-desktop-width-resp);
  margin: 0 auto;
  min-height: 1212px;

}

.scl--web-page-product-section-container {
  width: 100%;
  height: 100%;
}

.scl--web-page-product-section-inner {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
  height: 100%;
}

/* Left side: SectionTitle + SwitchContentButton */
.scl--web-page-product-service-side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 92px 0 94px;
  gap: 60px;
  width: 617px;
  min-width: 617px;
  min-height: 1212px;
  flex-shrink: 0;
}

/* Override SectionTitle colors for white background */
.scl--web-page-product-styled-section-title {
  align-items: flex-start;
}

.scl--web-page-product-styled-section-title .scl--web-component-section-title-text {
  color: #000000;
  font-size: 90px;
  line-height: 53px;
  font-weight: 600;
  letter-spacing: -4px;
}

.scl--web-page-product-styled-section-title .scl--web-component-section-label-text {
  color: rgba(0, 0, 0, 0.6);
}

.scl--web-page-product-styled-section-title .scl--web-component-section-left-bracket,
.scl--web-page-product-styled-section-title .scl--web-component-section-right-bracket {
  border-color: rgba(0, 0, 0, 0.6);
}

.scl--web-page-product-styled-section-title .scl--web-component-section-left-bracket {
  border-right-color: transparent;
}

.scl--web-page-product-styled-section-title .scl--web-component-section-right-bracket {
  border-left-color: transparent;
}

.scl--web-page-product-styled-section-title .scl--web-component-section-description-text {
  color: rgba(0, 0, 0, 0.6);
  width: 559px;
  font-size: 20px;
}

/* Service list container */
.scl--web-page-product-service-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0;
  gap: 10px;
  width: 559px;
}

.scl--web-page-product-section-box .scl--web-page-product-service-side .scl--web-component-section-label-container{
  padding-bottom: 65px;
}

/* Right side: Image content */
.scl--web-page-product-image-side {
  flex: 1;
  position: relative;
  align-self: stretch;
  overflow: hidden;
}

/* Allow overflow when options bar is visible to prevent clipping */
.scl--web-page-product-image-side:has(.scl--web-component-round-icon-button-options-bar.visible) {
  overflow: visible;
}

.scl--web-page-product-content-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: -2px;
  width: 100%;
  height: calc(100% + 2px);
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.scl--web-page-product-content-image.active {
  opacity: 1;
}

/* Round Icon Button positioned at top-right of image */
.scl--web-page-product-image-icon-button {
  position: absolute;
  top: 90px;
  right: 45px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* Show button on image hover */
.scl--web-page-product-image-side:hover .scl--web-page-product-image-icon-button {
  opacity: 1;
}

/* Keep button visible when options bar is open (even without hover) - target wrapper with :has() */
.scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {
  opacity: 1;
}

/* Hide options bar by default */
.scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {
  opacity: 0;
  pointer-events: none;
}

/* Show options bar when visible class is present (works with or without hover) */
.scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {
  opacity: 1;
  pointer-events: auto;
}
.scl--web-page-product-service-side .scl--web-component-section-title-container{
  gap: 20px;
}

/* Large screens (bigger than 1920px) - Full width image on right */
/* Large screens (bigger than 1920px) - Full width image on right */
@media screen and (min-width: 1921px) {
  .scl--web-page-product-section-box {
    position: relative;
    overflow: hidden; 
  }

  .scl--web-page-product-section {
    position: relative;
    overflow: visible;
  }

  .scl--web-page-product-section-container {
    position: relative;
    min-height: 1212px;
  }

  .scl--web-page-product-section-inner {
    position: relative;
    min-height: 1212px;
  }

  .scl--web-page-product-service-side {
    width: 617px;
    min-width: 617px;
    flex-shrink: 0;
    position: relative;
    z-index: 2;
  }

  /* Image side breaks out to viewport edge */
  .scl--web-page-product-image-side {
    position: absolute;
    top: 0;
    left: 617px;
    right: calc((100vw - var(--global-desktop-width-resp)) / -2);
    height: 1212px;
    width: auto;
  }


}
@media (max-width: 1728px) {
  .scl--web-page-product-section {
    padding: 0 0 0 var(--global-laptop-padding-left);
  }

  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text {
    width: 95%;
  }
}

@media screen and (max-width: 1440px) {
  .scl--web-page-product-section {
    padding: 0 0 0 var(--global-laptop-padding-left);
    min-height: 1000px;
  }

  .scl--web-page-product-service-side {
    width: 450px;
    min-width: 450px;
    min-height: 900px;
    padding: 60px 0 60px;
    gap: 40px;
  }

  .scl--web-page-product-service-list {
    width: 400px;
  }

  .scl--web-page-product-image-icon-button {
    top: 60px;
    right: 30px;
  }

  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {
    right: 30px;
    top: 120px;
  }
  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text{
    font-size: 60px;
  }
}

@media screen and (max-width: 1280px) {
  .scl--web-page-product-section {
    padding: 0;
    height: auto;
    min-height: auto;
  }

  .scl--web-page-product-section-inner {
    flex-direction: column;
  }

  .scl--web-page-product-service-side {
    width: 100%;
    min-width: unset;
    min-height: unset;
    padding: 80px 300px 0;
    gap: 40px;
    overflow: hidden;
  }

  .scl--web-page-product-service-list {
    width: 100%;
  }

  .scl--web-page-product-image-side {
    width: 100%;
    height: 900px;
    flex: none;
    margin-bottom: -2px;
  }

  .scl--web-page-product-image-icon-button {
    top: 50px;
    right: 50px;
    opacity: 1;
  }

  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {
    top: 50px;
    right: 110px;
  }

}

@media screen and (max-width: 850px) {
  .scl--web-page-product-section {
    padding: 0;
    height: auto;
    max-height: none;
    border-bottom: 1px solid rgba(233, 233, 233, 0.05);
  }

  .scl--web-page-product-section-inner {
    flex-direction: column;
  }

  .scl--web-page-product-service-side {
    width: 100%;
    min-width: unset;
    min-height: unset;
    padding: 79px 0 0;
    gap: 35px;
    overflow: hidden; /* Prevent parent overflow */
  }

  .scl--web-page-product-styled-section-title.scl--web-component-section-title-container {
    gap: 15px;
    padding: 0 27px;
  }

  .scl--web-page-product-styled-section-title .scl--web-component-section-label-text {
    font-size: 16px;
  }

  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text {
    font-size: 50px;
    line-height: 50px;
    letter-spacing: -2px;
  }

  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text {
    font-size: 28px;
    line-height: 30px;
    width: 100%;
  }

  /* Switch content: horizontal tabs layout */
  .scl--web-page-product-service-list {
    width: 100%;
    padding: 0;
    gap: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scl--web-page-product-service-list::-webkit-scrollbar {
    display: none;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-container {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-template-rows: auto auto;
    gap: 20px 40px;
    justify-content: flex-start;
    align-items: center;
    width: max-content; /* Allow to grow beyond viewport */
    min-width: calc(100% - 58px); /* Account for padding */
    padding: 0 27px; /* Inner padding */
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-item {
    display: contents;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-separator {
    display: none;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-row {
    grid-row: 1;
    margin-top: 0;
    position: relative;
    padding-bottom: 15px;
    width: fit-content;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-item.active .scl--web-component-switch-content-row::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 3, 7, 0.6) 0%, rgba(246, 6, 207, 0.6) 44.61%, rgba(0, 109, 217, 0.6) 100%);
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-title-wrapper {
    padding: 0;
    width: fit-content;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-title {
    font-size: 34px;
    font-weight: bold;
    line-height: 36px;
    letter-spacing: 0;
    white-space: nowrap;
    display: inline-block;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-icon-wrapper {
    display: none;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-description-wrapper {
    grid-row: 2;
    grid-column: 1 / -1;
    position: sticky;
    left: 29px;
    width: calc(100vw - 58px);
    max-width: calc(100vw - 58px);
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-description {
    font-size: 28px;
    line-height: 30px;
    padding-bottom: 30px;
    width: 100%;
  }

  .scl--web-page-product-image-side {
    width: 100%;
    height: 1130px;
    flex: none;
    margin-bottom: -2px;
  }

  .scl--web-page-product-content-image {
    border-radius: 0;
    /* Extend image slightly to cover any subpixel gaps */
    height: calc(100% + 2px);
  }

  .scl--web-page-product-image-icon-button {
    top: 33px;
    right: 35px;
    opacity: 1;
  }

  /* Hide options bar by default on tablet */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {
    opacity: 0;
    pointer-events: none;
    top: 35px;
    right: 90px;
  }

  /* Always show options bar when visible on tablet */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {
    opacity: 1;
    pointer-events: auto;
  }

  /* Keep icon button visible when options bar is open on tablet */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .scl--web-page-product-section {
    padding: 0;
  }

  .scl--web-page-product-service-side {
    padding: 79px 0 0;
    overflow: hidden; /* Prevent parent overflow */
    gap: 20px;
  }

  .scl--web-page-product-styled-section-title {
    padding: 0 var(var(--global-mobile-padding-left));
  }


  .scl--web-page-product-image-side {
    height: 710px;
  }

  .scl--web-page-product-image-icon-button {
    opacity: 1;
  }

  /* Hide options bar by default on mobile */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {
    opacity: 0;
    top: 90px;
    right: 210px;
    pointer-events: none;
  }

  /* Always show options bar when visible on mobile */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {
    opacity: 1;
    pointer-events: auto;
  }

  /* Keep icon button visible when options bar is open on mobile */
  .scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {
    opacity: 1;
  }

  .scl--web-page-product-service-list {
    padding: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text{
    font-size: 24px;
  }

  .scl--web-page-product-service-list::-webkit-scrollbar {
    display: none;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-container {
    grid-template-columns: repeat(3, auto);
    gap: 0 20px;
    justify-content: flex-start;
    width: max-content; /* Allow to grow beyond viewport */
    min-width: calc(100% - 28px); /* Account for padding */
    padding: 0 14px; /* Inner padding */
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-row {
    padding-bottom: 15px;
    width: fit-content;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-title-wrapper {
    width: fit-content;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-title {
    font-size: 34px;
    line-height: 32px;
    letter-spacing: 0.5px;
    white-space: nowrap;
    display: inline-block;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-description-wrapper {
    position: sticky;
    left: 14px;
    width: calc(100vw - 28px);
    max-width: calc(100vw - 28px);
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-description {
    font-size: 24px;
    padding: 0;

  }
  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text{
    font-size: 60px;
  }

  .scl--web-page-product-styled-section-title.scl--web-component-section-title-container{
    padding: 0 15px;
  }
  .scl--web-page-product-styled-section-title .scl--web-component-section-title-container{
    padding-left: 14px ;
    padding-right: 14px;
  }

  .scl--web-page-product-service-list .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper{
    margin-top: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/product/css/productSection.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA,mGAAmG;AACnG;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,iFAAiF;AACjF;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;EAEA,2CAA2C;EAC3C;IACE,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,4DAA4D;IAC5D,cAAc;IACd,WAAW;EACb;;;AAGF;AACA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;AAEF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kDAAkD;EACpD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,gBAAgB,EAAE,4BAA4B;EAChD;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,UAAU;IACV,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,6BAA6B;IAC7B,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB,EAAE,kCAAkC;IACtD,4BAA4B,EAAE,wBAAwB;IACtD,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,uHAAuH;EACzH;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,qDAAqD;IACrD,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA,0CAA0C;EAC1C;IACE,UAAU;IACV,oBAAoB;IACpB,SAAS;IACT,WAAW;EACb;;EAEA,mDAAmD;EACnD;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA,gEAAgE;EAChE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gBAAgB,EAAE,4BAA4B;IAC9C,SAAS;EACX;;EAEA;IACE,iDAAiD;EACnD;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA,0CAA0C;EAC1C;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,oBAAoB;EACtB;;EAEA,mDAAmD;EACnD;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA,gEAAgE;EAChE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sCAAsC;IACtC,WAAW;IACX,2BAA2B;IAC3B,kBAAkB,EAAE,kCAAkC;IACtD,4BAA4B,EAAE,wBAAwB;IACtD,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,UAAU;;EAEZ;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Product Solutions Section Styles */\n.scl--web-page-product-section-box{\n    min-height: 1212px;\n    width: 100%;\n    background: #FFFFFF;\n}\n.scl--web-page-product-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0 0 0 var(--global-desktop-padding-left);\n  max-width: var(--global-desktop-width-resp);\n  margin: 0 auto;\n  min-height: 1212px;\n\n}\n\n.scl--web-page-product-section-container {\n  width: 100%;\n  height: 100%;\n}\n\n.scl--web-page-product-section-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0;\n  height: 100%;\n}\n\n/* Left side: SectionTitle + SwitchContentButton */\n.scl--web-page-product-service-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 92px 0 94px;\n  gap: 60px;\n  width: 617px;\n  min-width: 617px;\n  min-height: 1212px;\n  flex-shrink: 0;\n}\n\n/* Override SectionTitle colors for white background */\n.scl--web-page-product-styled-section-title {\n  align-items: flex-start;\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-title-text {\n  color: #000000;\n  font-size: 90px;\n  line-height: 53px;\n  font-weight: 600;\n  letter-spacing: -4px;\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-label-text {\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-left-bracket,\n.scl--web-page-product-styled-section-title .scl--web-component-section-right-bracket {\n  border-color: rgba(0, 0, 0, 0.6);\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-left-bracket {\n  border-right-color: transparent;\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-right-bracket {\n  border-left-color: transparent;\n}\n\n.scl--web-page-product-styled-section-title .scl--web-component-section-description-text {\n  color: rgba(0, 0, 0, 0.6);\n  width: 559px;\n  font-size: 20px;\n}\n\n/* Service list container */\n.scl--web-page-product-service-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10px 0;\n  gap: 10px;\n  width: 559px;\n}\n\n.scl--web-page-product-section-box .scl--web-page-product-service-side .scl--web-component-section-label-container{\n  padding-bottom: 65px;\n}\n\n/* Right side: Image content */\n.scl--web-page-product-image-side {\n  flex: 1;\n  position: relative;\n  align-self: stretch;\n  overflow: hidden;\n}\n\n/* Allow overflow when options bar is visible to prevent clipping */\n.scl--web-page-product-image-side:has(.scl--web-component-round-icon-button-options-bar.visible) {\n  overflow: visible;\n}\n\n.scl--web-page-product-content-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: -2px;\n  width: 100%;\n  height: calc(100% + 2px);\n  object-fit: cover;\n  display: block;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.scl--web-page-product-content-image.active {\n  opacity: 1;\n}\n\n/* Round Icon Button positioned at top-right of image */\n.scl--web-page-product-image-icon-button {\n  position: absolute;\n  top: 90px;\n  right: 45px;\n  z-index: 2;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n/* Show button on image hover */\n.scl--web-page-product-image-side:hover .scl--web-page-product-image-icon-button {\n  opacity: 1;\n}\n\n/* Keep button visible when options bar is open (even without hover) - target wrapper with :has() */\n.scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {\n  opacity: 1;\n}\n\n/* Hide options bar by default */\n.scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Show options bar when visible class is present (works with or without hover) */\n.scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n.scl--web-page-product-service-side .scl--web-component-section-title-container{\n  gap: 20px;\n}\n\n/* Large screens (bigger than 1920px) - Full width image on right */\n/* Large screens (bigger than 1920px) - Full width image on right */\n@media screen and (min-width: 1921px) {\n  .scl--web-page-product-section-box {\n    position: relative;\n    overflow: hidden; \n  }\n\n  .scl--web-page-product-section {\n    position: relative;\n    overflow: visible;\n  }\n\n  .scl--web-page-product-section-container {\n    position: relative;\n    min-height: 1212px;\n  }\n\n  .scl--web-page-product-section-inner {\n    position: relative;\n    min-height: 1212px;\n  }\n\n  .scl--web-page-product-service-side {\n    width: 617px;\n    min-width: 617px;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 2;\n  }\n\n  /* Image side breaks out to viewport edge */\n  .scl--web-page-product-image-side {\n    position: absolute;\n    top: 0;\n    left: 617px;\n    right: calc((100vw - var(--global-desktop-width-resp)) / -2);\n    height: 1212px;\n    width: auto;\n  }\n\n\n}\n@media (max-width: 1728px) {\n  .scl--web-page-product-section {\n    padding: 0 0 0 var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text {\n    width: 95%;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .scl--web-page-product-section {\n    padding: 0 0 0 var(--global-laptop-padding-left);\n    min-height: 1000px;\n  }\n\n  .scl--web-page-product-service-side {\n    width: 450px;\n    min-width: 450px;\n    min-height: 900px;\n    padding: 60px 0 60px;\n    gap: 40px;\n  }\n\n  .scl--web-page-product-service-list {\n    width: 400px;\n  }\n\n  .scl--web-page-product-image-icon-button {\n    top: 60px;\n    right: 30px;\n  }\n\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {\n    right: 30px;\n    top: 120px;\n  }\n  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text{\n    font-size: 60px;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .scl--web-page-product-section {\n    padding: 0;\n    height: auto;\n    min-height: auto;\n  }\n\n  .scl--web-page-product-section-inner {\n    flex-direction: column;\n  }\n\n  .scl--web-page-product-service-side {\n    width: 100%;\n    min-width: unset;\n    min-height: unset;\n    padding: 80px 300px 0;\n    gap: 40px;\n    overflow: hidden;\n  }\n\n  .scl--web-page-product-service-list {\n    width: 100%;\n  }\n\n  .scl--web-page-product-image-side {\n    width: 100%;\n    height: 900px;\n    flex: none;\n    margin-bottom: -2px;\n  }\n\n  .scl--web-page-product-image-icon-button {\n    top: 50px;\n    right: 50px;\n    opacity: 1;\n  }\n\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {\n    top: 50px;\n    right: 110px;\n  }\n\n}\n\n@media screen and (max-width: 850px) {\n  .scl--web-page-product-section {\n    padding: 0;\n    height: auto;\n    max-height: none;\n    border-bottom: 1px solid rgba(233, 233, 233, 0.05);\n  }\n\n  .scl--web-page-product-section-inner {\n    flex-direction: column;\n  }\n\n  .scl--web-page-product-service-side {\n    width: 100%;\n    min-width: unset;\n    min-height: unset;\n    padding: 79px 0 0;\n    gap: 35px;\n    overflow: hidden; /* Prevent parent overflow */\n  }\n\n  .scl--web-page-product-styled-section-title.scl--web-component-section-title-container {\n    gap: 15px;\n    padding: 0 27px;\n  }\n\n  .scl--web-page-product-styled-section-title .scl--web-component-section-label-text {\n    font-size: 16px;\n  }\n\n  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text {\n    font-size: 50px;\n    line-height: 50px;\n    letter-spacing: -2px;\n  }\n\n  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text {\n    font-size: 28px;\n    line-height: 30px;\n    width: 100%;\n  }\n\n  /* Switch content: horizontal tabs layout */\n  .scl--web-page-product-service-list {\n    width: 100%;\n    padding: 0;\n    gap: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .scl--web-page-product-service-list::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-container {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: auto auto;\n    gap: 20px 40px;\n    justify-content: flex-start;\n    align-items: center;\n    width: max-content; /* Allow to grow beyond viewport */\n    min-width: calc(100% - 58px); /* Account for padding */\n    padding: 0 27px; /* Inner padding */\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-item {\n    display: contents;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-separator {\n    display: none;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-row {\n    grid-row: 1;\n    margin-top: 0;\n    position: relative;\n    padding-bottom: 15px;\n    width: fit-content;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-item.active .scl--web-component-switch-content-row::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(90deg, rgba(255, 3, 7, 0.6) 0%, rgba(246, 6, 207, 0.6) 44.61%, rgba(0, 109, 217, 0.6) 100%);\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-title-wrapper {\n    padding: 0;\n    width: fit-content;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-title {\n    font-size: 34px;\n    font-weight: bold;\n    line-height: 36px;\n    letter-spacing: 0;\n    white-space: nowrap;\n    display: inline-block;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-icon-wrapper {\n    display: none;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-description-wrapper {\n    grid-row: 2;\n    grid-column: 1 / -1;\n    position: sticky;\n    left: 29px;\n    width: calc(100vw - 58px);\n    max-width: calc(100vw - 58px);\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-description {\n    font-size: 28px;\n    line-height: 30px;\n    padding-bottom: 30px;\n    width: 100%;\n  }\n\n  .scl--web-page-product-image-side {\n    width: 100%;\n    height: 1130px;\n    flex: none;\n    margin-bottom: -2px;\n  }\n\n  .scl--web-page-product-content-image {\n    border-radius: 0;\n    /* Extend image slightly to cover any subpixel gaps */\n    height: calc(100% + 2px);\n  }\n\n  .scl--web-page-product-image-icon-button {\n    top: 33px;\n    right: 35px;\n    opacity: 1;\n  }\n\n  /* Hide options bar by default on tablet */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {\n    opacity: 0;\n    pointer-events: none;\n    top: 35px;\n    right: 90px;\n  }\n\n  /* Always show options bar when visible on tablet */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  /* Keep icon button visible when options bar is open on tablet */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .scl--web-page-product-section {\n    padding: 0;\n  }\n\n  .scl--web-page-product-service-side {\n    padding: 79px 0 0;\n    overflow: hidden; /* Prevent parent overflow */\n    gap: 20px;\n  }\n\n  .scl--web-page-product-styled-section-title {\n    padding: 0 var(var(--global-mobile-padding-left));\n  }\n\n\n  .scl--web-page-product-image-side {\n    height: 710px;\n  }\n\n  .scl--web-page-product-image-icon-button {\n    opacity: 1;\n  }\n\n  /* Hide options bar by default on mobile */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar {\n    opacity: 0;\n    top: 90px;\n    right: 210px;\n    pointer-events: none;\n  }\n\n  /* Always show options bar when visible on mobile */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-options-bar.visible {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  /* Keep icon button visible when options bar is open on mobile */\n  .scl--web-page-product-image-side .scl--web-component-round-icon-button-wrapper:has(.scl--web-component-round-icon-button-options-bar.visible) .scl--web-page-product-image-icon-button {\n    opacity: 1;\n  }\n\n  .scl--web-page-product-service-list {\n    padding: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .scl--web-page-product-styled-section-title .scl--web-component-section-description-text{\n    font-size: 24px;\n  }\n\n  .scl--web-page-product-service-list::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-container {\n    grid-template-columns: repeat(3, auto);\n    gap: 0 20px;\n    justify-content: flex-start;\n    width: max-content; /* Allow to grow beyond viewport */\n    min-width: calc(100% - 28px); /* Account for padding */\n    padding: 0 14px; /* Inner padding */\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-row {\n    padding-bottom: 15px;\n    width: fit-content;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-title-wrapper {\n    width: fit-content;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-title {\n    font-size: 34px;\n    line-height: 32px;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n    display: inline-block;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-description-wrapper {\n    position: sticky;\n    left: 14px;\n    width: calc(100vw - 28px);\n    max-width: calc(100vw - 28px);\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-description {\n    font-size: 24px;\n    padding: 0;\n\n  }\n  .scl--web-page-product-styled-section-title .scl--web-component-section-title-text{\n    font-size: 60px;\n  }\n\n  .scl--web-page-product-styled-section-title.scl--web-component-section-title-container{\n    padding: 0 15px;\n  }\n  .scl--web-page-product-styled-section-title .scl--web-component-section-title-container{\n    padding-left: 14px ;\n    padding-right: 14px;\n  }\n\n  .scl--web-page-product-service-list .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper{\n    margin-top: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
